<template>
  <collapsible-widget
    title="PLANY INWESTYCYJNE"
    :maxHeight="30"
    :expand-widget="pwidLayersExpanded"
    :accordion="accordion"
    @toggled="onToggled"
    ref="collapsible"
    :default-expanded="pwidLayersExpanded"
    :selectAllEnabled="pwidLayersHasItems"
    :onCheckboxChanged="onCheckboxChanged"
    :allSelected.sync="allSelected"
    :indeterminate="indeterminate"
  >
    <composition-layers
      :layers="pwidLayers"
      @set-layer-extent="setLayerExtent"
    ></composition-layers>
  </collapsible-widget>
</template>

<script>
import { mapGetters } from 'vuex';
import CollapsibleWidget from './CollapsibleWidget';
import CompositionLayers from './CompositionLayers';
import {
  PWID_LAYERS_EXPANDED_SET,
  SET_LAYER_VISIBILITY
} from '../store/mutations.type';

export default {
  name: 'Compositions',
  props: {
    accordion: {
      type: String,
      default: 'panel'
    }
  },
  components: {
    CollapsibleWidget,
    CompositionLayers
  },
  computed: {
    ...mapGetters(['readOnly', 'pwidLayersExpanded']),
    pwidLayers() {
      return Array(
        ...this.$store.getters.pwidLayers.sort((a, b) => {
          return b.order - a.order;
        })
      );
    },
    pwidLayersHasItems() {
      return this.pwidLayers.length > 0;
    },
    indeterminate() {
      return (
        this.pwidLayers.some(l => l.visible) &&
        this.pwidLayers.some(l => !l.visible)
      );
    },
    allSelected() {
      return this.pwidLayers.every(l => l.visible);
    }
  },
  methods: {
    onToggled(expanded) {
      this.$emit('toggled', expanded);
      this.$store.commit(PWID_LAYERS_EXPANDED_SET, (expanded || {}).expanded);
    },
    onCheckboxChanged(value) {
      if (value) {
        this.pwidLayers.forEach(layer => {
          this.$store.commit(SET_LAYER_VISIBILITY, {
            layerId: layer.id,
            visible: true
          });
        });
      } else {
        this.pwidLayers.forEach(layer => {
          this.$store.commit(SET_LAYER_VISIBILITY, {
            layerId: layer.id,
            visible: false
          });
        });
      }
    },
    setLayerExtent(extent) {
      this.$emit('set-layer-extent', extent);
    }
  }
};
</script>
